'use client';
import { useEffect } from 'react';
import { Box } from 'ui/components/box';

export default function PrivacyPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <Box
        css={{
          width: 'width.parent',
          maxWidth: ['maxWidth.bodyChild.mobile', 'maxWidth.bodyChild.sm'],
          paddingBottom: '10rem',
        }}
        data-id='c58d64c0-cfca-45e2-82ce-fb059b549356'
        data-type='iframe'
        // @ts-ignore
        name='termly-embed'
      />
    </>
  );
}
